<template>
    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
        <v-text-field
            v-model="usuario.username"
            :rules="obligatorio"
            label="Nombre de usuario"
            required
            variant="solo"
        ></v-text-field>
        <v-text-field
            v-model="usuario.email"
            :rules="opcionalMail"
            label="Email"
            variant="solo"
        ></v-text-field>
        <v-autocomplete
            v-model="usuario.rol"
            variant="solo"
            :items="roles"
            item-title="name"
            item-value="value"
            :rules="obligatorio"
            :loading="cargandoRoles"
            label="Rol"
            required
            class="asterisco"
        ></v-autocomplete>
        <ObrasSocialesTotSelect
            v-if="usuario.rol === Auditor"
            @os-seleccionada="obraSocialId = $event">
        </ObrasSocialesTotSelect>
        <BandejasSelect
            v-if="usuario.rol === Autorizador"
            @bandeja-seleccionada="bandejaId = $event">
        </BandejasSelect>
        <FacturadoresTotSelect
            v-if="usuario.rol !== Auditor && usuario.rol !== Autorizador"
            @facturador-seleccionado="facturadorId = $event">
        </FacturadoresTotSelect>
        <v-btn
            type="submit"
            :disabled="!valid"
            id="boton-verde"
            :loading="cargando"
        >
            Crear usuario
        </v-btn>
    </v-form>
    <ClosableAlert
        v-if="alert"
        :type="alertType"
        :key="alertKey"
        :texto="mensaje"
        titulo="Agregar usuario"
    ></ClosableAlert>
</template>
<style src="../assets/general.css"></style>
<script>
/* eslint-disable */
import Usuario from '@/interfaces/usuarioInterfaces';
import {obligatorioMail, obligatorio, opcionalMail} from '@/_helpers/rules';
import AuthService from '@/api/AuthService';
import AdminService from '@/api/AdminService';
import ClosableAlert from './ClosableAlert.vue';
import FacturadoresTotSelect from './FacturadoresTotSelect.vue';
import {RoleNumeros} from '@/_helpers/role.ts';
import ObrasSocialesTotSelect from './ObrasSocialesTotSelect.vue';
import BandejasSelect from './BandejasSelect.vue';

const authService = new AuthService();
const adminService = new AdminService();

export default {
    components: {
        ClosableAlert,
        FacturadoresTotSelect,
        ObrasSocialesTotSelect,
        BandejasSelect
    },
    data() {
        return {
            valid: false,
            usuario: Usuario = {},
            facturadorId: null,
            obraSocialId: null,
            bandejaId: null,
            obligatorio: obligatorio,
            obligatorioMail: obligatorioMail,
            opcionalMail: opcionalMail,
            cargando: false,
            roles: [],
            cargandoRoles: false,
            //datos de alerta
            alert: false,
            alertType: 'error',
            alertKey: 0,
            mensaje: '',
            Auditor: RoleNumeros.Auditor,
            Autorizador: RoleNumeros.Autorizador
        }
    },
    async mounted() {
        await this.cargarRoles();
    },
    methods: {
        async handleSubmit() {
            this.cargando = true;
            const response = await adminService.crearUsuario(this.usuario, this.facturadorId, this.obraSocialId, this.bandejaId);
            if(response && response.status === 200) {
                this.alertType = 'success';
                this.mensaje = 'Usuario creado correctamente';
            } else {
                this.alertType = 'info';
                this.mensaje = response.response.data || 'Error al crear el usuario';
            }
            this.alert = true;
            this.alertKey += 1;
            this.cargando = false;
        },
        facturadorTitle(item){
            if (!item) return '';
            return `${item.cuitFacturador} - ${item.nombre}`;
        },
        async cargarRoles() {
            this.cargandoRoles = true;
            const response = await authService.getRoles();
            if(response) {
                response.forEach((rol) => {
                    this.roles.push({name: rol.name, value: rol.value.toString()});
                });
            }
            this.cargandoRoles = false;
        }
    }
}
</script>